import { QuestionContent, QuestionLabel, QuestionWrap } from './shared.styles';

function Question({ label, children }) {
  return (
    <QuestionWrap>
      <QuestionLabel>{label}</QuestionLabel>
      <QuestionContent>{children}</QuestionContent>
    </QuestionWrap>
  );
}

export default Question;
